import {useIsSuperuser, useUser} from "../../../utils/UserSession";
import {Button, Stack} from "react-bootstrap";
import {Link} from "react-router";
import {useCallback, useContext} from "react";
import {ChangePasswordDialogContext} from "zavadil-react-common";
import {useRestClient} from "../../../client/SpmRestClient";
import {useAlerts} from "../../../utils/UserAlerts";
import BackIconLink from "../../../components/BackIconLink";

export default function ProfilePage() {
	const user = useUser();
	const isSuperuser = useIsSuperuser();
	const restClient = useRestClient();
	const userAlers = useAlerts();
	const changePasswordDialog = useContext(ChangePasswordDialogContext);

	const changePassword = useCallback(
		() => {
			changePasswordDialog.show(
				{
					name: 'Změnit heslo',
					onClose: () => changePasswordDialog.hide(),
					onConfirm: (password) => {
						restClient.users
							.changeMyPassword(password)
							.catch((e) => userAlers.err(e))
							.then(() => {
								userAlers.info("Heslo bylo změněno");
								changePasswordDialog.hide();
							});
					}
				}
			)
		},
		[changePasswordDialog, restClient, userAlers]
	);

	return <Stack gap={2}>
		<h1>Profil</h1>
		<Stack direction="horizontal">
			<BackIconLink/>
		</Stack>
		<div>
			<div>Email</div>
			<div><strong>{user.email}</strong></div>
		</div>
		<div>
			<div>Jméno</div>
			<div><strong>{user.name}</strong></div>
		</div>
		<div>
			<div>Role</div>
			<div><strong>{user.roles.map(r => r.name).join(', ')}</strong></div>
		</div>
		<Stack direction="horizontal" gap={2} className="mt-2">
			<Button onClick={changePassword}>Změnit heslo...</Button>
			{
				isSuperuser && <>
					<Link to={`/admin/users/${user.id}`} className="btn btn-primary">Upravit...</Link>
				</>
			}
		</Stack>
	</Stack>
};
